import { useContext } from "react";
import FactorContext from "../context/FactorContext";
import DiscountSection from "./discount/DiscountSection";
import PayButtons from "./payButtons/PayButtons";

function PaySection() {
  const { factorDetail } = useContext(FactorContext);

  const sumRealPayable = factorDetail.shipments?.reduce(
    (sum, { item }) => sum + item.realPayable + item.amountCOD,
    0
  );

  return (
    <section className="mt-4">
      <p style={{ fontFamily: "iran" }} className="text-center">
        <span>مجموع سفارش: </span>
        <span className="text-success fs-3 mx-2">
          {isNaN(sumRealPayable) ? 0 : sumRealPayable.toLocaleString()}
        </span>
        <small> ریال</small>
      </p>
      <DiscountSection />
      <p className="text-center">
        موجودی کیف پول شما: {factorDetail.wallet.toLocaleString()} ريال
      </p>
      <PayButtons />
    </section>
  );
}

export default PaySection;
